import Component from 'vue-class-component';
import {
  ClubCardUser, ClubCardUserResponse, Shopper, UserRegisterResponse,
  UserApiService
} from '@/services/generated/edge/user';
import {RegistrationVue} from "@/registration-vue";
import './security-entry.scss';
declare var dataLayer: any;
declare var memberStatus: boolean;
@Component({template: require('./security-entry.html')})
export class SecurityEntryPage extends RegistrationVue {

  termsVisible: boolean = false;
  showPassword: boolean = false;
  passwordFocused: boolean = false;
  loading = false;
  comms = false;
  some = false;
  agree = false;

  mounted() {
    dataLayer.push({
      'event': 'stepLoaded',
      'stepNumber': '3',
      'stepName': 'Enter details to complete sign up'
    });
    if (!this.$store.state.phoneNumber && this.$store.state.presetPhoneNumber) {
      this.$store.state.phoneNumber = this.$store.state.presetPhoneNumber;
    }

    this.$validator.updateDictionary({
      en: {
        custom: {
          phoneNumber: {
            required: 'Please enter your phone number'
          },
          password: {
            required: 'You need to set up the password'
          },
          answer: {
            required: 'Please enter the answer for the question'
          },
          agree: {
            required: 'We need you to agree to proceed'
          },
          title: {
            required: 'Please select your title'
          }
        }
      }
    });
  }

  toggleShowPassword() {
    this.$refs.passwordField['type'] = this.$refs.passwordField['type'] == 'password' ? 'text' : 'password';
    this.$refs.passwordField['focus']();
  }

  next() {
    this.doIfFormIsValid(() => {
      this.loading = true;
      const password = (<HTMLInputElement>this.$refs.passwordField).value;
      if (this.$store.state.isQuickShopper) {
        const quickShopperUser = new Shopper({
          firstName: this.$store.state.firstName,
          lastName: this.$store.state.lastName,
          email: this.$store.state.email,
          password: password,
          phone: this.$store.state.phoneNumber,
          agreedToTermsAndConditions: true,
          agreedToMarketing: this.$store.state.agreeComms
        });

        UserApiService.registerUser(quickShopperUser).then((response) => {
            dataLayer.push({
              'event': 'successfulSubmission',
              'memberStatus': memberStatus
            });
          this.autologin(response);
        }).catch((error) => {
          this.handleRegistrationError(error);
        });
      } else {
        const clubcardUser = new ClubCardUser({
          firstName: this.$store.state.firstName,
          lastName: this.$store.state.lastName,
          email: this.$store.state.email,
          password: password,
          phone: this.$store.state.phoneNumber,
          securityQuestion: this.$store.state.securityQuestions[this.$store.state.securityQuestion],
          securityAnswer: this.$store.state.securityAnswer,
          clubCard: this.$store.state.clubcardNumber.replace(/ /g, ''),
          agreedToMarketing: this.$store.state.agreeComms,
          title: this.$store.state.title
        });

        UserApiService.completeRegistration(clubcardUser).then((response) => {
            dataLayer.push({
              'event': 'successfulSubmission',
              'memberStatus': memberStatus
            });
          this.autologin(response);
        }).catch((error) => {
          this.handleRegistrationError(error);
        });
      }
      
    });
  }

  autologin(response: UserRegisterResponse | ClubCardUserResponse) {
    document.location.href = document.location.href + `?customer_id=${encodeURIComponent(response.userId)}&access_token=${encodeURIComponent(response.token)}&anonymous_id=2323&refresh_token=${encodeURIComponent(response.refresh)}&status=${encodeURIComponent(response.status)}`;
    let customerId = response.userId;
    dataLayer.push({
      'event': 'BPIDAvailable',
      'BPID': customerId
    });
  }

  handleRegistrationError(error) {
    if (error && error.response && error.response.data && error.response.data.message) {
      if (error.response.data.message == 'This phone number is not valid') {
        this.invalidateField('phoneNumber', 'This phone number is not valid');
      } else {
        this.handleApiError(error);
      }
    } else {
      this.handleApiError(error);
    }
    this.loading = false;
  }

}



// WEBPACK FOOTER //
// ./src/pages/forms/security-entry/security-entry.ts